module.exports = __webpack_public_path__ + "static/media/icomoon.d3333828.woff2";